import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=5293255c&scoped=true&"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=5293255c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293255c",
  null
  
)

export default component.exports